//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: Search component
//
//  Copyright:    © 2021 - 2026 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//region Version 1.0.0.0
//    001            Sean Flook                  Initial Revision.
//    002   05.04.23 Sean Flook          WI40596 If opening an historic property display the warning dialog.
//    003   18.04.23 Sean Flook          WI40687 Handle a 204 response.
//    004   21.04.23 Sean Flook          WI40693 If no records found display a message informing the user of the fact.
//    005   24.04.23 Sean Flook          WI40695 Do not bother doing an object comparison if we do not have a current object.
//    006   28.06.23 Sean Flook          WI40256 Changed Extent to Provenance where appropriate.
//    007   07.09.23 Sean Flook                  Added code to handle unassigned ESUs.
//    008   06.10.23 Sean Flook                  Added some error trapping and use colour variables.
//    009   27.10.23 Sean Flook                  Updated call to SavePropertyAndUpdate.
//    010   03.11.23 Sean Flook                  Hide the filter and sort buttons for now.
//    011   10.11.23 Sean Flook                  Removed HasASDPlus as no longer required.
//    012   20.11.23 Sean Flook                  Tweak the classification code for street BLPUs.
//    013   20.11.23 Sean Flook                  Undone above change.
//    014   24.11.23 Sean Flook                  Moved Box to @mui/system.
//    015   02.01.24 Sean Flook                  Changed console.log to console.error for error messages.
//    016   05.01.24 Sean Flook                  Changes to sort out warnings and use CSS shortcuts.
//    017   25.01.24 Sean Flook                  Correctly handle status code 204.
//    018   26.01.24 Sean Flook        IMANN-260 Corrected field name.
//    019   01.02.24 Joel Benford      GLB9      Adjust placement/sizing
//    020   09.02.24 Sean Flook                  Modified handleHistoricPropertyClose to handle returning an action from the historic property warning dialog.
//    021   09.02.24 Sean Flook                  If only 1 record found in search pressing the Enter key will open the record.
//    022   13.02.24 Sean Flook                  Corrected the type 66 map data.
//    023   16.02.24 Sean Flook         ESU27_GP Tweaked styling for new Add street button.
//    024   27.02.24 Sean Flook            MUL16 Changes required to allow control to be used for make child of dialog.
//    025   08.03.24 Sean Flook        IMANN-348 Use the new hasStreetChanged and hasPropertyChanged methods as well as updated calls to ResetContexts.
//    026   04.04.24 Sean Flook                  Added parentUprn to mapContext search data for properties.
//    027   30.04.24 Sean Flook                  Handle nulls being returned by the Scottish API for ASD records when none are present.
//    028   14.05.24 Sean Flook        IMANN-206 Changes required to display all the provenances.
//    029   29.05.24 Sean Flook        IMANN-411 Added missing else statement.
//    030   19.06.24 Sean Flook        IMANN-629 Changes to code so that current user is remembered and a 401 error displays the login dialog.
//    031   20.06.24 Sean Flook        IMANN-636 Use the new user rights.
//    032   24.06.24 Sean Flook        IMANN-170 Changes required for cascading parent PAO changes to children.
//    033   03.07.24 Joshua McCormick  IMANN-542 Searching when inside a property will now directly open property instead of showing search list
//    034   08.07.24 Sean Flook        IMANN-728 Only get the background properties and provenances if the user can see properties.
//    035   18.07.24 Sean Flook        IMANN-772 Corrected field name.
//    036   10.09.24 Sean Flook        IMANN-980 Only write to the console if the user has the showMessages right.
//endregion Version 1.0.0.0
//region Version 1.0.1.0
//    037   02.10.24 Sean Flook        IMANN-996 Call onEditMapObject when opening a property.
//    038   14.10.24 Sean Flook       IMANN-1016 Changes required to handle LLPG Streets.
//endregion Version 1.0.1.0
//region Version 1.0.2.0
//    039   12.11.24 Sean Flook                  Anchor the filter dialog to the filter button when displaying.
//endregion Version 1.0.2.0
//region Version 1.0.3.0
//    040   09.01.25 Sean Flook        IMANN-781 Include the pkId in the extent object.
//    041   09.01.25 Sean Flook       IMANN-1125 Only get background data if required.
//endregion Version 1.0.3.0
//region Version 1.0.4.0
//    042   04.02.25 Sean Flook       IMANN-1674 Use the same zoom level for background streets and properties.
//endregion Version 1.0.4.0
//region Version 1.0.5.0
//    043   27.01.25 Sean Flook       IMANN-1077 Upgraded MUI to v6.
//    044   30.01.25 Sean Flook       IMANN-1673 Changes required for new user settings API.
//    045   29.05.25 Sean Flook       IMANN-1802 Use the new GetSearchStreetMapData method rather than looping through the streets individually.
//endregion Version 1.0.5.0
//region Version 1.0.6.0
//    046   16.06.25 Sean Flook       IMANN-1811 Prevent the search being done again if the search string has not changed.
//    047   30.06.25 Sean Flook       IMANN-1833 When generating the street map data if there are no ESUs generate a dummy one using the start and end coordinates of the street.
//    048   17.07.25 Sean Flook       IMANN-1864 Updated call to SavePropertyAndUpdate.
//    049   11.08.25 Sean Flook       IMANN-1980 Only enable the search button if the input value is more than 1 character long.
//    050   11.08.25 Sean Flook       IMANN-1980 After selecting a search item, clear the input field.
//endregion Version 1.0.6.0
//region Version 1.0.6.1
//    051   01.09.25 Sean Flook       IMANN-2008 Encode the search string before sending it to the API.
//    052   02.09.25 Sean Flook       IMANN-2011 If a parent has been moved ask user if they also want to move its children as well.
//    053   04.09.25 Sean Flook       IMANN-2023 Comment out code to ask user if they want to edit historic properties.
//endregion Version 1.0.6.1
//region Version 1.0.7.0
//    054   13.06.25 Sean Flook       IMANN-1812 Modified to use the new Sandbox store.
//    055   28.08.25 Sean Flook       IMANN-1812 Changes required to update MUI to v7.
//    056   28.08.25 Sean Flook       IMANN-1812 Updated renderOption in Autocomplete.
//    057   23.09.25 Sean Flook       IMANN-2041 Set the historical field for extents.
//    058   17.12.25 Sean Flook       IMANN-2197 Correctly call resetSandbox.
//    059   21.01.26 Sean Flook       IMANN-2204 Replaced calls to GetWktCoordinates with wktToGeometry.
//    060   11.02.26 Sean Flook       IMANN-2282 Tidied up getting background data.
//    061   26.02.26 Sean Flook       IMANN-2324 Modified call to GetSearchStreetMapData.
//    062   08.04.26 Sean Flook       IMANN-2398 For properties ensure we are passing a number to onEditMapObject, also restrict to English records for the map data to prevent duplicates from being shown.
//endregion Version 1.0.7.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

//region imports

import React, { useContext, useState, useRef, useEffect, Fragment } from "react";
import PropTypes from "prop-types";

import useSandboxStore from "../context/SandboxStore";

import SearchContext from "../context/searchContext";
import StreetContext from "../context/streetContext";
import PropertyContext from "../context/propertyContext";
import UserContext from "../context/userContext";
import MapContext from "../context/mapContext";
import LookupContext from "../context/lookupContext";
import SettingsContext from "../context/settingsContext";

import {
  Autocomplete,
  TextField,
  InputAdornment,
  IconButton,
  Popper,
  Typography,
  Snackbar,
  Alert,
  Stack,
  Box,
} from "@mui/material";
import ADSFilterControl from "./ADSFilterControl";

import { autocompleteClasses } from "@mui/material/Autocomplete";
import {
  GetBackgroundStreetsUrl,
  GetUnassignedEsusUrl,
  GetBackgroundPropertiesUrl,
  GetBackgroundProvenancesUrl,
  GetSearchURL,
} from "../configuration/ADSConfig";
import { wktToGeometry, ResetContexts } from "../utils/HelperUtils";
import {
  GetSearchStreetMapData,
  GetStreetMapData,
  GetCurrentStreetData,
  SaveStreet,
  HasStreetChanged,
  getChangedAssociatedStreetRecords,
} from "../utils/StreetUtils";
import {
  addressToTitleCase,
  GetPropertyMapData,
  GetCurrentPropertyData,
  SavePropertyAndUpdate,
  HasPropertyChanged,
  hasParentPaoChanged,
  hasParentMoved,
  getChangedAssociatedPropertyRecords,
} from "../utils/PropertyUtils";

import { useSaveConfirmation } from "../pages/SaveConfirmationPage";
// TODO: uncommented below code when want to reintroduce asking to edit historic.
// import HistoricPropertyDialog from "../dialogs/HistoricPropertyDialog";

import GetClassificationIcon from "../utils/ADSClassificationIcons";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import TuneIcon from "@mui/icons-material/Tune";
import ClearIcon from "@mui/icons-material/Clear";
import { StreetIcon } from "../utils/ADSIcons";

import { adsBlueA, adsMidGreyA, adsLightGreyB, adsLightGreyA50, adsPaleBlueA, adsMidGreyB } from "../utils/ADSColours";
import {
  ActionIconStyle,
  GetAlertStyle,
  GetAlertIcon,
  GetAlertSeverity,
  ClearSearchIconStyle,
} from "../utils/ADSStyles";
import { useTheme, styled } from "@mui/material/styles";
import userContext from "../context/userContext";

//endregion imports

const apiFetch = async (url, headers, dataIfAborted, signal) => {
  try {
    const response = await fetch(url, {
      headers: headers,
      crossDomain: true,
      method: "GET",
      signal,
    });

    switch (response.status) {
      case 200:
        const data = await response.json();
        return data;

      case 204:
        return [{ type: 24, uprn: 0, address: "No records found", postcode: "" }];

      case 401:
        userContext.onExpired();
        return [{ type: 24, uprn: 0, address: "Search failed...", postcode: "" }];

      default:
        return [{ type: 24, uprn: 0, address: "Search failed...", postcode: "" }];
    }
  } catch (err) {
    if (err.name === "AbortError") {
      return dataIfAborted;
    }
    return err;
  }
};

const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.paper}`]: {
    mt: "20px",
    border: "1px",
    borderColor: adsLightGreyB,
    boxShadow: `4px 4px 7px ${adsLightGreyA50}`,
    borderRadius: "6px",
  },
});

ADSSearch.propTypes = {
  variant: PropTypes.oneOf(["appBar", "makeChild"]).isRequired,
  placeholder: PropTypes.string.isRequired,
  onSearchClick: PropTypes.func.isRequired,
};

function ADSSearch({ variant = "appBar", placeholder, onSearchClick }) {
  const theme = useTheme();

  const sandboxStore = useSandboxStore((state) => state);
  const sourceStreet = useSandboxStore((state) => state.sourceStreet);
  const currentStreet = useSandboxStore((state) => state.currentStreet);
  const currentDescriptorRecord = useSandboxStore((state) => state.currentDescriptorRecord);
  const currentEsuRecord = useSandboxStore((state) => state.currentEsuRecord);
  const currentHighwayDedicationRecord = useSandboxStore((state) => state.currentHighwayDedicationRecord);
  const currentOneWayExemptionRecord = useSandboxStore((state) => state.currentOneWayExemptionRecord);
  const currentMaintenanceResponsibilityRecord = useSandboxStore(
    (state) => state.currentMaintenanceResponsibilityRecord
  );
  const currentReinstatementCategoryRecord = useSandboxStore((state) => state.currentReinstatementCategoryRecord);
  const currentOSSpecialDesignationRecord = useSandboxStore((state) => state.currentOSSpecialDesignationRecord);
  const currentInterestRecord = useSandboxStore((state) => state.currentInterestRecord);
  const currentConstructionRecord = useSandboxStore((state) => state.currentConstructionRecord);
  const currentSpecialDesignationRecord = useSandboxStore((state) => state.currentSpecialDesignationRecord);
  const currentHWWRecord = useSandboxStore((state) => state.currentHWWRecord);
  const currentPRoWRecord = useSandboxStore((state) => state.currentPRoWRecord);
  const currentStreetNoteRecord = useSandboxStore((state) => state.currentStreetNoteRecord);
  const sourceProperty = useSandboxStore((state) => state.sourceProperty);
  const currentProperty = useSandboxStore((state) => state.currentProperty);
  const currentLpiRecord = useSandboxStore((state) => state.currentLpiRecord);
  const currentProvenanceRecord = useSandboxStore((state) => state.currentProvenanceRecord);
  const currentAppCrossRefRecord = useSandboxStore((state) => state.currentAppCrossRefRecord);
  const currentClassificationRecord = useSandboxStore((state) => state.currentClassificationRecord);
  const currentOrganisationRecord = useSandboxStore((state) => state.currentOrganisationRecord);
  const currentSuccessorCrossRefRecord = useSandboxStore((state) => state.currentSuccessorCrossRefRecord);
  const currentPropertyNoteRecord = useSandboxStore((state) => state.currentPropertyNoteRecord);
  const setStore = useSandboxStore((state) => state.setStore);
  const resetSandbox = useSandboxStore((state) => state.resetSandbox);

  const searchContext = useContext(SearchContext);
  const streetContext = useContext(StreetContext);
  const propertyContext = useContext(PropertyContext);
  const mapContext = useContext(MapContext);
  const userContext = useContext(UserContext);
  const lookupContext = useContext(LookupContext);
  const settingsContext = useContext(SettingsContext);

  const [data, setData] = useState([]);
  const [urlDetails, setUrlDetails] = useState(null);
  const [search, setSearch] = useState();
  const [showIcons, setShowIcons] = useState(false);
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [maxResults, setMaxResults] = useState(8);
  const currentSearch = useRef(null);
  const backgroundStreetData = useRef(null);
  const unassignedEsuData = useRef(null);
  const backgroundPropertyData = useRef(null);
  const backgroundProvenanceData = useRef(null);
  const searchStreets = useRef(null);
  const searchLlpgStreets = useRef(null);
  const searchProperties = useRef(null);

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const filterOpen = Boolean(filterAnchorEl);
  const filterId = filterOpen ? "filter-popper" : undefined;

  const saveConfirmDialog = useSaveConfirmation();
  const [saveOpen, setSaveOpen] = useState(false);
  const saveResult = useRef(null);
  const saveType = useRef(null);
  const failedValidation = useRef(null);
  const associatedRecords = useRef([]);

  // TODO: uncommented below code when want to reintroduce asking to edit historic.
  // const [openHistoricProperty, setOpenHistoricProperty] = useState(false);
  // const historicRec = useRef(null);

  const [hasASD, setHasASD] = useState(false);

  /**
   * Method to get the API URL details.
   */
  const GetApiSite = () => {
    if (!urlDetails && userContext.currentUser) {
      const url = GetSearchURL(userContext.currentUser);
      setUrlDetails(url);
    }
  };

  /**
   * Event to handle when the search string changes.
   *
   * @param {object} event The event object.
   * @param {string} newInputValue The new search string.
   */
  const onSearchChange = (event, newInputValue) => {
    if (!urlDetails) GetApiSite();

    setSearch(newInputValue);
    setInputValue(newInputValue);
  };

  /**
   * Event to handle when the search control gets focus.
   */
  const onSearchFocus = () => {
    setShowIcons(true);
  };

  /**
   * Event to handle when the search control losses focus.
   */
  const onSearchBlur = () => {
    setShowIcons(filterAnchorEl || false);
  };

  /**
   * Event to handle when the search button is clicked.
   */
  async function handleSearchClick() {
    const searchStreetMapData = await GetSearchStreetMapData(
      data.filter((x) => x.type === 15 && x.language === "ENG"),
      userContext.currentUser,
      userContext.onExpired,
      settingsContext.isScottish
    );

    searchStreets.current = userContext.currentUser.hasStreet ? searchStreetMapData : [];

    searchLlpgStreets.current = !userContext.currentUser.hasStreet ? searchStreetMapData : [];

    searchProperties.current = data
      .filter((x) => x.type === 24 && x.language === "ENG")
      .map((x) => {
        let propObj = {
          uprn: x.uprn,
          parentUprn: x.parent_uprn,
          address: x.address,
          formattedAddress: x.formattedaddress,
          postcode: x.postcode,
          easting: x.easting,
          northing: x.northing,
          logicalStatus: x.logical_status,
          classificationCode: x.classification_code ? x.classification_code : "U",
        };
        return propObj;
      });

    mapContext.onSearchDataChange(
      searchStreets.current,
      searchLlpgStreets.current,
      searchProperties.current,
      null,
      null
    );
    searchContext.onSearchDataChange(search, data);
    searchContext.onSearchOpen(false);
    if (onSearchClick) onSearchClick();
  }

  /**
   * Event to handle when the save alert is closed.
   *
   * @param {object} event The event object.
   * @param {string} reason The reason the alert is being closed.
   * @returns
   */
  const handleSaveClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSaveOpen(false);
  };

  /**
   * Event to handle saving a street.
   *
   * @param {object} currentStreet The current streets data.
   */
  function HandleSaveStreet(currentStreet) {
    SaveStreet(
      currentStreet,
      streetContext,
      userContext,
      lookupContext,
      searchContext,
      mapContext,
      sandboxStore,
      settingsContext.isScottish,
      settingsContext.isWelsh
    ).then((result) => {
      if (result.street) {
        saveResult.current = true;
        saveType.current = "street";
        setStore(result.store);
        setSaveOpen(true);
      } else {
        saveResult.current = false;
        saveType.current = "street";
        setSaveOpen(true);
      }
    });
  }

  /**
   * Event to handle saving a property.
   *
   * @param {object} currentProperty The current property data.
   * @param {boolean} cascadeParentPaoChanges If true the child property PAO details need to be changed; otherwise they are not changed.
   * @param {boolean} cascadeMove True if the changes to the property location need to be cascaded down to the children; otherwise false.
   */
  function HandleSaveProperty(currentProperty, cascadeParentPaoChanges, cascadeMove) {
    SavePropertyAndUpdate(
      currentProperty,
      propertyContext.currentProperty.newProperty,
      propertyContext,
      userContext,
      searchContext,
      mapContext,
      sandboxStore,
      settingsContext.isScottish,
      settingsContext.isWelsh,
      cascadeParentPaoChanges,
      cascadeMove
    ).then((result) => {
      if (result.property) {
        saveResult.current = true;
        saveType.current = "property";
        setStore(result.store);
        setSaveOpen(true);
      } else {
        saveResult.current = false;
        saveType.current = "property";
        setSaveOpen(true);
      }
    });
  }

  /**
   * Event to check there are no outstanding changes before doing a new search.
   */
  async function handleSearchCheck() {
    if (sourceStreet) {
      const streetChanged = HasStreetChanged(
        streetContext.currentStreet.newStreet,
        sourceStreet,
        currentDescriptorRecord,
        currentEsuRecord,
        currentHighwayDedicationRecord,
        currentOneWayExemptionRecord,
        currentMaintenanceResponsibilityRecord,
        currentReinstatementCategoryRecord,
        currentOSSpecialDesignationRecord,
        currentInterestRecord,
        currentConstructionRecord,
        currentSpecialDesignationRecord,
        currentHWWRecord,
        currentPRoWRecord,
        currentStreetNoteRecord,
        currentStreet,
        hasASD
      );

      if (streetChanged) {
        associatedRecords.current = getChangedAssociatedStreetRecords(
          sourceStreet,
          currentDescriptorRecord,
          currentEsuRecord,
          currentHighwayDedicationRecord,
          currentOneWayExemptionRecord,
          currentMaintenanceResponsibilityRecord,
          currentReinstatementCategoryRecord,
          currentOSSpecialDesignationRecord,
          currentInterestRecord,
          currentConstructionRecord,
          currentSpecialDesignationRecord,
          currentHWWRecord,
          currentPRoWRecord,
          currentStreetNoteRecord,
          currentStreet,
          streetContext.esuDataChanged
        );

        const streetData = currentStreet ? currentStreet : sourceStreet;

        if (associatedRecords.current.length > 0) {
          saveConfirmDialog(associatedRecords.current)
            .then((result) => {
              if (result === "save") {
                if (streetContext.validateData()) {
                  failedValidation.current = false;
                  const currentStreetData = GetCurrentStreetData(
                    streetData,
                    currentDescriptorRecord,
                    currentEsuRecord,
                    currentStreetNoteRecord,
                    currentMaintenanceResponsibilityRecord,
                    currentReinstatementCategoryRecord,
                    currentOSSpecialDesignationRecord,
                    currentInterestRecord,
                    currentConstructionRecord,
                    currentSpecialDesignationRecord,
                    currentHWWRecord,
                    currentPRoWRecord,
                    lookupContext,
                    settingsContext.isWelsh,
                    settingsContext.isScottish,
                    hasASD
                  );
                  HandleSaveStreet(currentStreetData);
                } else {
                  failedValidation.current = true;
                  saveResult.current = false;
                  setSaveOpen(true);
                }
              }
              ResetContexts("street", mapContext, streetContext, propertyContext);
              resetSandbox("street");
              handleSearchClick();
            })
            .catch(() => {});
        } else {
          saveConfirmDialog(true)
            .then((result) => {
              if (result === "save") {
                HandleSaveStreet(currentStreet);
              }
              ResetContexts("street", mapContext, streetContext, propertyContext);
              resetSandbox("street");
              handleSearchClick();
            })
            .catch(() => {});
        }
      } else {
        ResetContexts("street", mapContext, streetContext, propertyContext);
        resetSandbox("street");
        handleSearchClick();
      }
    } else if (sourceProperty) {
      const propertyChanged = HasPropertyChanged(
        propertyContext.currentProperty.newProperty,
        sourceProperty,
        currentLpiRecord,
        currentProvenanceRecord,
        currentAppCrossRefRecord,
        currentClassificationRecord,
        currentOrganisationRecord,
        currentSuccessorCrossRefRecord,
        currentPropertyNoteRecord,
        currentProperty
      );

      if (propertyChanged) {
        associatedRecords.current = getChangedAssociatedPropertyRecords(
          sourceProperty,
          currentLpiRecord,
          currentProvenanceRecord,
          currentAppCrossRefRecord,
          currentClassificationRecord,
          currentOrganisationRecord,
          currentSuccessorCrossRefRecord,
          currentPropertyNoteRecord
        );

        const parentPaoChanged = hasParentPaoChanged(
          propertyContext.childCount,
          sourceProperty,
          currentProperty,
          associatedRecords.current.length > 0 && associatedRecords.current.includes("LPI") ? currentLpiRecord : null
        );

        const parentMoved = hasParentMoved(propertyContext.childCount, sourceProperty, currentProperty);

        const propertyData = currentProperty ? currentProperty : sourceProperty;

        if (associatedRecords.current.length > 0) {
          saveConfirmDialog(associatedRecords.current, parentPaoChanged, parentMoved)
            .then((result) => {
              if (result === "save" || result === "saveCascade") {
                if (propertyContext.validateData()) {
                  failedValidation.current = false;
                  const currentPropertyData = GetCurrentPropertyData(
                    propertyData,
                    currentLpiRecord,
                    currentProvenanceRecord,
                    currentAppCrossRefRecord,
                    currentClassificationRecord,
                    currentOrganisationRecord,
                    currentSuccessorCrossRefRecord,
                    currentPropertyNoteRecord,
                    lookupContext,
                    settingsContext.isWelsh,
                    settingsContext.isScottish
                  );
                  HandleSaveProperty(
                    currentPropertyData,
                    result === "saveCascade" || result === "saveCascadeMove",
                    result === "saveCascadeMove" || result === "saveMove"
                  );
                  ResetContexts("property", mapContext, streetContext, propertyContext);
                  resetSandbox("property");
                  handleSearchClick();
                } else {
                  failedValidation.current = true;
                  saveResult.current = false;
                  setSaveOpen(true);
                }
              } else {
                ResetContexts("property", mapContext, streetContext, propertyContext);
                resetSandbox("property");
                handleSearchClick();
              }
            })
            .catch(() => {});
        } else {
          saveConfirmDialog(true, parentPaoChanged, parentMoved)
            .then((result) => {
              if (result === "save" || result === "saveCascade") {
                HandleSaveProperty(
                  currentProperty,
                  result === "saveCascade" || result === "saveCascadeMove",
                  result === "saveCascadeMove" || result === "saveMove"
                );
              }
              ResetContexts("property", mapContext, streetContext, propertyContext);
              resetSandbox("property");
              handleSearchClick();
            })
            .catch(() => {});
        }
      } else {
        ResetContexts("property", mapContext, streetContext, propertyContext);
        resetSandbox("property");
        handleSearchClick();
      }
    } else {
      ResetContexts("all", mapContext, streetContext, propertyContext);
      resetSandbox("all");
      handleSearchClick();
    }
  }

  /**
   * Event to handle when the clear search button is clicked.
   */
  const handleClearSearch = () => {
    setValue(null);
    setInputValue("");
    setSearch(null);
    currentSearch.current = null;
  };

  /**
   * Event to handle when a key is pressed down.
   *
   * @param {object} event The event object.
   */
  const handleKeyDown = (event) => {
    event.stopPropagation();
    if (event.key === "Enter") {
      event.preventDefault();
      if (data && data.length === 1) {
        onSelectCheck(event, data[0]);
      } else if (variant === "appBar") {
        handleSearchCheck();
      }
    }
  };

  /**
   * Event to handle when the filter button is clicked.
   */
  const handleFilterClick = () => {
    setFilterAnchorEl(filterAnchorEl ? null : document.getElementById("filter-button"));
  };

  /**
   * Event to handle filtering the search results.
   */
  const handleFilterResults = () => {};

  /**
   * Event to handle cancelling the filtering of the search results.
   */
  const handleCancelFilter = () => {
    setFilterAnchorEl(null);
  };

  /**
   * Event to handle when the query builder button is clicked.
   */
  const handleQueryBuilderClick = () => {};

  /**
   * Event to handle opening a property.
   *
   * @param {object} rec The property record.
   */
  const doOpenProperty = async (rec) => {
    propertyContext.onPropertyChange(
      rec.uprn,
      0,
      rec.address,
      rec.formattedaddress,
      rec.postcode,
      rec.easting,
      rec.northing,
      false,
      null
    );
    searchProperties.current = [
      {
        uprn: rec.uprn,
        parentUprn: rec.parent_uprn,
        address: rec.address,
        formattedAddress: rec.formattedAddress,
        postcode: rec.postcode,
        easting: rec.easting,
        northing: rec.northing,
        logicalStatus: rec.logical_status,
        classificationCode: rec.classification_code ? rec.classification_code : "U",
      },
    ];
    const propertyData = await GetPropertyMapData(rec.uprn, userContext);
    const extents = propertyData
      ? propertyData.blpuProvenances.map((provRec) => ({
          pkId: provRec.pkId,
          uprn: rec.uprn,
          code: provRec.provenanceCode,
          historical: !!provRec.endDate,
          geometry: provRec.wktGeometry && provRec.wktGeometry !== "" ? wktToGeometry(provRec.wktGeometry) : undefined,
        }))
      : undefined;
    searchStreets.current = [];
    searchLlpgStreets.current = [];
    mapContext.onSearchDataChange(
      searchStreets.current,
      searchLlpgStreets.current,
      searchProperties.current,
      null,
      rec.uprn
    );
    mapContext.onMapChange(extents, null, null);
    mapContext.onEditMapObject(21, Number(rec.uprn));
  };

  /**
   * Event to handle closing the historic property dialog.
   *
   * @param {string} action The action taken from the dialog
   */
  // TODO: uncommented below code when want to reintroduce asking to edit historic.
  // const handleHistoricPropertyClose = (action) => {
  //   setOpenHistoricProperty(false);
  //   if (action === "continue") {
  //     if (historicRec.current) doOpenProperty(historicRec.current);
  //   }
  // };

  /**
   * Event to handle when the selection changes in the dropdown list.
   *
   * @param {object} newValue The selected record.
   */
  async function onSelectChange(newValue) {
    if (newValue) {
      if (newValue.usrn && !newValue.uprn) {
        streetContext.onStreetChange(newValue.usrn, newValue.street, false);
        const streetData = await GetStreetMapData(newValue.usrn, userContext, settingsContext.isScottish);
        const esus = streetData
          ? userContext.currentUser.hasStreet
            ? streetData.esus && streetData.esus.length > 0
              ? streetData.esus.map((rec) => ({
                  esuId: rec.esuId,
                  state: settingsContext.isScottish && rec ? rec.state : undefined,
                  geometry: rec.wktGeometry && rec.wktGeometry !== "" ? wktToGeometry(rec.wktGeometry) : undefined,
                }))
              : [
                  {
                    esuId: -1,
                    state: undefined,
                    geometry: wktToGeometry(
                      `LINESTRING (${streetData.streetStartX} ${streetData.streetStartY}, ${streetData.streetEndX} ${streetData.streetEndY})`
                    ),
                  },
                ]
            : [
                {
                  esuId: -1,
                  state: undefined,
                  geometry: wktToGeometry(
                    `LINESTRING (${streetData.streetStartX} ${streetData.streetStartY}, ${streetData.streetEndX} ${streetData.streetEndY})`
                  ),
                },
              ]
          : [];

        const asdType51 =
          userContext.currentUser.hasStreet &&
          settingsContext.isScottish &&
          streetData &&
          streetData.maintenanceResponsibilities
            ? streetData.maintenanceResponsibilities.map((asdRec) => ({
                type: 51,
                pkId: asdRec.pkId,
                usrn: asdRec.usrn,
                streetStatus: asdRec.streetStatus,
                custodianCode: asdRec.custodianCode,
                maintainingAuthorityCode: asdRec.maintainingAuthorityCode,
                wholeRoad: asdRec.wholeRoad,
                geometry:
                  asdRec.wktGeometry && asdRec.wktGeometry !== "" ? wktToGeometry(asdRec.wktGeometry) : undefined,
              }))
            : [];

        const asdType52 =
          userContext.currentUser.hasStreet &&
          settingsContext.isScottish &&
          streetData &&
          streetData.reinstatementCategories
            ? streetData.reinstatementCategories.map((asdRec) => ({
                type: 52,
                pkId: asdRec.pkId,
                usrn: asdRec.usrn,
                reinstatementCategoryCode: asdRec.reinstatementCategoryCode,
                custodianCode: asdRec.custodianCode,
                reinstatementAuthorityCode: asdRec.reinstatementAuthorityCode,
                wholeRoad: asdRec.wholeRoad,
                geometry:
                  asdRec.wktGeometry && asdRec.wktGeometry !== "" ? wktToGeometry(asdRec.wktGeometry) : undefined,
              }))
            : [];

        const asdType53 =
          userContext.currentUser.hasStreet &&
          settingsContext.isScottish &&
          streetData &&
          streetData.specialDesignations
            ? streetData.specialDesignations.map((asdRec) => ({
                type: 53,
                pkId: asdRec.pkId,
                usrn: asdRec.usrn,
                specialDesignationCode: asdRec.specialDesignationCode,
                custodianCode: asdRec.custodianCode,
                authorityCode: asdRec.authorityCode,
                wholeRoad: asdRec.wholeRoad,
                geometry:
                  asdRec.wktGeometry && asdRec.wktGeometry !== "" ? wktToGeometry(asdRec.wktGeometry) : undefined,
              }))
            : [];

        const asdType61 =
          userContext.currentUser.hasStreet &&
          !settingsContext.isScottish &&
          hasASD &&
          streetData &&
          streetData.interests
            ? streetData.interests.map((asdRec) => ({
                type: 61,
                pkId: asdRec.pkId,
                usrn: asdRec.usrn,
                streetStatus: asdRec.streetStatus,
                interestType: asdRec.interestType,
                districtRefAuthority: asdRec.districtRefAuthority,
                swaOrgRefAuthority: asdRec.swaOrgRefAuthority,
                wholeRoad: asdRec.wholeRoad,
                geometry:
                  asdRec.wktGeometry && asdRec.wktGeometry !== "" ? wktToGeometry(asdRec.wktGeometry) : undefined,
              }))
            : [];

        const asdType62 =
          userContext.currentUser.hasStreet &&
          !settingsContext.isScottish &&
          hasASD &&
          streetData &&
          streetData.constructions
            ? streetData.constructions.map((asdRec) => ({
                type: 62,
                pkId: asdRec.pkId,
                usrn: asdRec.usrn,
                constructionType: asdRec.constructionType,
                reinstatementTypeCode: asdRec.reinstatementTypeCode,
                swaOrgRefConsultant: asdRec.swaOrgRefConsultant,
                districtRefConsultant: asdRec.districtRefConsultant,
                wholeRoad: asdRec.wholeRoad,
                geometry:
                  asdRec.wktGeometry && asdRec.wktGeometry !== "" ? wktToGeometry(asdRec.wktGeometry) : undefined,
              }))
            : [];

        const asdType63 =
          userContext.currentUser.hasStreet &&
          !settingsContext.isScottish &&
          hasASD &&
          streetData &&
          streetData.specialDesignations
            ? streetData.specialDesignations.map((asdRec) => ({
                type: 63,
                pkId: asdRec.pkId,
                usrn: asdRec.usrn,
                streetSpecialDesigCode: asdRec.streetSpecialDesigCode,
                swaOrgRefConsultant: asdRec.swaOrgRefConsultant,
                districtRefConsultant: asdRec.districtRefConsultant,
                wholeRoad: asdRec.wholeRoad,
                geometry:
                  asdRec.wktGeometry && asdRec.wktGeometry !== "" ? wktToGeometry(asdRec.wktGeometry) : undefined,
              }))
            : [];

        const asdType64 =
          userContext.currentUser.hasStreet &&
          !settingsContext.isScottish &&
          hasASD &&
          streetData &&
          streetData.heightWidthWeights
            ? streetData.heightWidthWeights.map((asdRec) => ({
                type: 64,
                pkId: asdRec.pkId,
                usrn: asdRec.usrn,
                hwwRestrictionCode: asdRec.hwwRestrictionCode,
                swaOrgRefConsultant: asdRec.swaOrgRefConsultant,
                districtRefConsultant: asdRec.districtRefConsultant,
                wholeRoad: asdRec.wholeRoad,
                geometry:
                  asdRec.wktGeometry && asdRec.wktGeometry !== "" ? wktToGeometry(asdRec.wktGeometry) : undefined,
              }))
            : [];

        const asdType66 =
          userContext.currentUser.hasStreet &&
          !settingsContext.isScottish &&
          hasASD &&
          streetData &&
          streetData.publicRightOfWays
            ? streetData.publicRightOfWays.map((asdRec) => ({
                type: 66,
                pkId: asdRec.pkId,
                prowUsrn: asdRec.prowUsrn,
                prowRights: asdRec.prowRights,
                prowStatus: asdRec.prowStatus,
                prowOrgRefConsultant: asdRec.prowOrgRefConsultant,
                prowDistrictRefConsultant: asdRec.prowDistrictRefConsultant,
                defMapGeometryType: asdRec.defMapGeometryType,
                geometry:
                  asdRec.wktGeometry && asdRec.wktGeometry !== "" ? wktToGeometry(asdRec.wktGeometry) : undefined,
              }))
            : [];

        searchStreets.current = userContext.currentUser.hasStreet
          ? [
              {
                usrn: newValue.usrn,
                description: newValue.street,
                language: newValue.language,
                locality: newValue.locality,
                town: newValue.town,
                state: !settingsContext.isScottish && streetData ? streetData.state : undefined,
                type: streetData ? streetData.recordType : undefined,
                esus: esus,
                asdType51: asdType51,
                asdType52: asdType52,
                asdType53: asdType53,
                asdType61: asdType61,
                asdType62: asdType62,
                asdType63: asdType63,
                asdType64: asdType64,
                asdType66: asdType66,
              },
            ]
          : [];

        searchLlpgStreets.current = !userContext.currentUser.hasStreet
          ? [
              {
                usrn: newValue.usrn,
                description: newValue.street,
                language: newValue.language,
                locality: newValue.locality,
                town: newValue.town,
                state: !settingsContext.isScottish && streetData ? streetData.state : undefined,
                type: streetData ? streetData.recordType : undefined,
                esus: esus,
                asdType51: [],
                asdType52: [],
                asdType53: [],
                asdType61: [],
                asdType62: [],
                asdType63: [],
                asdType64: [],
                asdType66: [],
              },
            ]
          : [];

        searchProperties.current = [];

        mapContext.onSearchDataChange(
          searchStreets.current,
          searchLlpgStreets.current,
          searchProperties.current,
          newValue.usrn,
          null
        );
      }

      if (newValue.uprn) {
        // TODO: uncommented below code when want to reintroduce asking to edit historic.
        // if (newValue.logical_status === 8) {
        //   historicRec.current = newValue;
        //   setOpenHistoricProperty(true);
        // } else
        doOpenProperty(newValue);
      }

      handleClearSearch();
    }
  }

  /**
   * Event to handle checking for any unsaved changes to the data before selecting a new record.
   *
   * @param {object} event The event object.
   * @param {object} newValue The selected record.
   */
  function onSelectCheck(event, newValue) {
    event.stopPropagation();

    if (variant === "appBar") {
      if (sourceStreet) {
        const streetChanged = HasStreetChanged(
          streetContext.currentStreet.newStreet,
          sourceStreet,
          currentDescriptorRecord,
          currentEsuRecord,
          currentHighwayDedicationRecord,
          currentOneWayExemptionRecord,
          currentMaintenanceResponsibilityRecord,
          currentReinstatementCategoryRecord,
          currentOSSpecialDesignationRecord,
          currentInterestRecord,
          currentConstructionRecord,
          currentSpecialDesignationRecord,
          currentHWWRecord,
          currentPRoWRecord,
          currentStreetNoteRecord,
          currentStreet,
          hasASD
        );

        if (streetChanged) {
          saveConfirmDialog(true)
            .then((result) => {
              if (result === "save") {
                // if (process.env.NODE_ENV === "development")
              }
              ResetContexts("street", mapContext, streetContext, propertyContext);
              resetSandbox("street");
              onSelectChange(newValue);
            })
            .catch(() => {});
        } else {
          ResetContexts("street", mapContext, streetContext, propertyContext);
          resetSandbox("street");
          onSelectChange(newValue);
        }
      } else if (sourceProperty) {
        const propertyChanged = HasPropertyChanged(
          propertyContext.currentProperty.newProperty,
          sourceProperty,
          currentLpiRecord,
          currentProvenanceRecord,
          currentAppCrossRefRecord,
          currentClassificationRecord,
          currentOrganisationRecord,
          currentSuccessorCrossRefRecord,
          currentPropertyNoteRecord,
          currentProperty
        );

        if (propertyChanged) {
          associatedRecords.current = getChangedAssociatedPropertyRecords(
            sourceProperty,
            currentLpiRecord,
            currentProvenanceRecord,
            currentAppCrossRefRecord,
            currentClassificationRecord,
            currentOrganisationRecord,
            currentSuccessorCrossRefRecord,
            currentPropertyNoteRecord
          );

          const parentPaoChanged = hasParentPaoChanged(
            propertyContext.childCount,
            sourceProperty,
            currentProperty,
            associatedRecords.current.length > 0 && associatedRecords.current.includes("LPI") ? currentLpiRecord : null
          );

          const parentMoved = hasParentMoved(propertyContext.childCount, sourceProperty, currentProperty);

          const propertyData = currentProperty ? currentProperty : sourceProperty;

          if (associatedRecords.current.length > 0) {
            saveConfirmDialog(associatedRecords.current, parentPaoChanged, parentMoved)
              .then((result) => {
                if (result === "save" || result === "saveCascade") {
                  const currentPropertyData = GetCurrentPropertyData(
                    propertyData,
                    currentLpiRecord,
                    currentProvenanceRecord,
                    currentAppCrossRefRecord,
                    currentClassificationRecord,
                    currentOrganisationRecord,
                    currentSuccessorCrossRefRecord,
                    currentPropertyNoteRecord,
                    lookupContext,
                    settingsContext.isWelsh,
                    settingsContext.isScottish
                  );
                  HandleSaveProperty(
                    currentPropertyData,
                    result === "saveCascade" || result === "saveCascadeMove",
                    result === "saveCascadeMove" || result === "saveMove"
                  );
                }
                ResetContexts("property", mapContext, streetContext, propertyContext);
                resetSandbox("property");
                handleSearchClick();
              })
              .catch(() => {});
          } else {
            saveConfirmDialog(true, parentPaoChanged, parentMoved)
              .then((result) => {
                if (result === "save" || result === "saveCascade") {
                  HandleSaveProperty(
                    currentProperty,
                    result === "saveCascade" || result === "saveCascadeMove",
                    result === "saveCascadeMove" || result === "saveMove"
                  );
                }
                ResetContexts("property", mapContext, streetContext, propertyContext);
                resetSandbox("property");
                handleSearchClick();
              })
              .catch(() => {});
          }
        } else {
          ResetContexts("property", mapContext, streetContext, propertyContext);
          resetSandbox("property");
          onSelectChange(newValue);
        }
      } else {
        ResetContexts("all", mapContext, streetContext, propertyContext);
        resetSandbox("all");
        onSelectChange(newValue);
      }
    } else {
      if (newValue && newValue.type === 24 && onSearchClick) onSearchClick(newValue);
    }
  }

  const getSearchStyle = () => {
    if (variant === "appBar") {
      return {
        color: adsMidGreyA,
        fontFamily: "Nunito Sans",
        fontSize: "15px",
        display: "inline-flex",
        pl: theme.spacing(1),
        pr: theme.spacing(1),
        borderStyle: "solid",
        borderWidth: "1px",
        borderRadius: "18px",
        mt: "8px",
        height: "32px",
        transition: theme.transitions.create("width"),
        [theme.breakpoints.up("sm")]: {
          width: "176px",
          borderColor: adsLightGreyB,
          "&:focus-within": {
            width: "640px",
            borderColor: adsMidGreyB,
          },
        },
      };
    } else {
      return {
        color: adsMidGreyA,
        fontFamily: "Nunito Sans",
        fontSize: "15px",
        display: "inline-flex",
        pl: theme.spacing(1),
        pr: theme.spacing(1),
        borderStyle: "solid",
        borderWidth: "1px",
        borderRadius: "18px",
        mt: "8px",
        height: "32px",
        width: "540px",
        borderColor: adsLightGreyB,
        "&:focus-within": {
          borderColor: adsMidGreyB,
        },
      };
    }
  };

  useEffect(() => {
    const controller = new window.AbortController();

    if (search && search.length > 0 && search !== currentSearch.current) {
      currentSearch.current = search;
      if (urlDetails) {
        // if (urlDetails && search && search.length > 0) {
        const whileWaiting = [{ type: 24, uprn: 0, address: "Loading Data...", postcode: "" }];

        setData(whileWaiting);

        const signal = controller.signal;

        const url = `${urlDetails.url}/${encodeURIComponent(search)}`;
        apiFetch(url, urlDetails.headers, whileWaiting, signal).then((res) => {
          if (variant === "appBar") {
            setData(res);
          } else {
            setData(res.filter((x) => x.type === 24));
          }
        });
      } else {
        setData([]);
      }
    }

    async function GetBackgroundStreetData() {
      if (!userContext.currentUser || !mapContext.currentExtent || mapContext.currentExtent.zoomLevel < 16) return;

      const backgroundStreetsUrl = GetBackgroundStreetsUrl(userContext.currentUser);

      if (backgroundStreetsUrl) {
        const returnValue = await fetch(
          `${backgroundStreetsUrl.url}?XMin=${mapContext.currentExtent.xmin}&YMin=${mapContext.currentExtent.ymin}&XMax=${mapContext.currentExtent.xmax}&YMax=${mapContext.currentExtent.ymax}`,
          {
            headers: backgroundStreetsUrl.headers,
            crossDomain: true,
            method: "GET",
          }
        )
          .then((res) => (res.ok ? res : Promise.reject(res)))
          .then((res) => {
            if (res.status && res.status === 204) return [];
            else return res.json();
          })
          .then((result) => {
            return result;
          })
          .catch((res) => {
            switch (res.status) {
              case 400:
                res.json().then((body) => {
                  if (userContext.currentUser.showMessages)
                    console.error(`[400 ERROR] Getting all Street data`, body.errors);
                });
                return null;

              case 401:
                userContext.onExpired();
                return null;

              case 500:
                if (userContext.currentUser.showMessages) console.error(`[500 ERROR] Getting all Street data`, res);
                return null;

              default:
                if (userContext.currentUser.showMessages)
                  console.error(`[${res.status} ERROR] Getting all Street data`, res);
                return null;
            }
          });

        backgroundStreetData.current = returnValue ? returnValue : undefined;

        mapContext.onBackgroundDataChange(
          backgroundStreetData.current,
          unassignedEsuData.current,
          backgroundPropertyData.current,
          backgroundProvenanceData.current
        );
      }
    }

    async function GetUnassignedEsuData() {
      if (!userContext.currentUser || !mapContext.currentExtent || mapContext.currentExtent.zoomLevel < 16) return;

      const unassignedEsusUrl = GetUnassignedEsusUrl(userContext.currentUser);

      if (unassignedEsusUrl) {
        const returnValue = await fetch(
          `${unassignedEsusUrl.url}?XMin=${mapContext.currentExtent.xmin}&YMin=${mapContext.currentExtent.ymin}&XMax=${mapContext.currentExtent.xmax}&YMax=${mapContext.currentExtent.ymax}`,
          {
            headers: unassignedEsusUrl.headers,
            crossDomain: true,
            method: "GET",
          }
        )
          .then((res) => (res.ok ? res : Promise.reject(res)))
          .then((res) => {
            if (res.status && res.status === 204) return [];
            else return res.json();
          })
          .then((result) => {
            return result;
          })
          .catch((res) => {
            switch (res.status) {
              case 400:
                res.json().then((body) => {
                  if (userContext.currentUser.showMessages)
                    console.error(`[400 ERROR] Getting all unassigned ESU data`, body.errors);
                });
                return null;

              case 401:
                userContext.onExpired();
                return null;

              case 500:
                if (userContext.currentUser.showMessages)
                  console.error(`[500 ERROR] Getting all unassigned ESU data`, res);
                return null;

              default:
                if (userContext.currentUser.showMessages)
                  console.error(`[${res.status} ERROR] Getting all unassigned ESU data`, res);
                return null;
            }
          });

        unassignedEsuData.current = returnValue ? returnValue : undefined;

        mapContext.onBackgroundDataChange(
          backgroundStreetData.current,
          unassignedEsuData.current,
          backgroundPropertyData.current,
          backgroundProvenanceData.current
        );
      }
    }

    async function GetBackgroundPropertyData() {
      if (!userContext.currentUser || !mapContext.currentExtent || mapContext.currentExtent.zoomLevel < 16) return;

      const backgroundPropertiesUrl = GetBackgroundPropertiesUrl(userContext.currentUser);

      if (backgroundPropertiesUrl) {
        const returnValue = await fetch(
          `${backgroundPropertiesUrl.url}?XMin=${mapContext.currentExtent.xmin}&YMin=${mapContext.currentExtent.ymin}&XMax=${mapContext.currentExtent.xmax}&YMax=${mapContext.currentExtent.ymax}`,
          {
            headers: backgroundPropertiesUrl.headers,
            crossDomain: true,
            method: "GET",
          }
        )
          .then((res) => (res.ok ? res : Promise.reject(res)))
          .then((res) => {
            if (res.status && res.status === 204) return [];
            else return res.json();
          })
          .then((result) => {
            return result;
          })
          .catch((res) => {
            switch (res.status) {
              case 400:
                res.json().then((body) => {
                  if (userContext.currentUser.showMessages)
                    console.error(`[400 ERROR] Getting all property data`, body.errors);
                });
                return null;

              case 401:
                userContext.onExpired();
                return null;

              case 500:
                if (userContext.currentUser.showMessages) console.error(`[500 ERROR] Getting all property data`, res);
                return null;

              default:
                if (userContext.currentUser.showMessages)
                  console.error(`[${res.status} ERROR] Getting all property data`, res);
                return null;
            }
          });

        backgroundPropertyData.current = returnValue ? returnValue : undefined;

        mapContext.onBackgroundDataChange(
          backgroundStreetData.current,
          unassignedEsuData.current,
          backgroundPropertyData.current,
          backgroundProvenanceData.current
        );
      }
    }

    async function GetBackgroundProvenanceData() {
      if (!userContext.currentUser || !mapContext.currentExtent || mapContext.currentExtent.zoomLevel < 16) return;

      const backgroundProvenancesUrl = GetBackgroundProvenancesUrl(userContext.currentUser);

      if (backgroundProvenancesUrl) {
        const returnValue = await fetch(
          `${backgroundProvenancesUrl.url}?XMin=${mapContext.currentExtent.xmin}&YMin=${mapContext.currentExtent.ymin}&XMax=${mapContext.currentExtent.xmax}&YMax=${mapContext.currentExtent.ymax}`,
          {
            headers: backgroundProvenancesUrl.headers,
            crossDomain: true,
            method: "GET",
          }
        )
          .then((res) => (res.ok ? res : Promise.reject(res)))
          .then((res) => {
            if (res.status && res.status === 204) return [];
            else return res.json();
          })
          .then((result) => {
            return result;
          })
          .catch((res) => {
            switch (res.status) {
              case 400:
                res.json().then((body) => {
                  if (userContext.currentUser.showMessages)
                    console.error(`[400 ERROR] Getting all provenance data`, body.errors);
                });
                return null;

              case 401:
                userContext.onExpired();
                return null;

              case 500:
                if (userContext.currentUser.showMessages) console.error(`[500 ERROR] Getting all provenance data`, res);
                return null;

              default:
                if (userContext.currentUser.showMessages)
                  console.error(`[${res.status} ERROR] Getting all provenance data`, res);
                return null;
            }
          });

        backgroundProvenanceData.current = returnValue ? returnValue : undefined;

        mapContext.onBackgroundDataChange(
          backgroundStreetData.current,
          unassignedEsuData.current,
          backgroundPropertyData.current,
          backgroundProvenanceData.current
        );
      }
    }

    if (
      variant === "appBar" &&
      !backgroundStreetData.current &&
      mapContext.currentBackgroundData?.streets?.length === 0 &&
      mapContext.currentExtent?.zoomLevel > 15
    ) {
      GetBackgroundStreetData();
    }

    if (
      variant === "appBar" &&
      !unassignedEsuData.current &&
      mapContext.currentBackgroundData?.unassignedEsus?.length === 0 &&
      mapContext.currentExtent?.zoomLevel > 15
    ) {
      GetUnassignedEsuData();
    }

    if (
      variant === "appBar" &&
      !backgroundPropertyData.current &&
      mapContext.currentBackgroundData?.properties?.length === 0 &&
      mapContext.currentExtent?.zoomLevel > 15 &&
      userContext.currentUser?.hasProperty
    ) {
      GetBackgroundPropertyData();
    }

    if (
      variant === "appBar" &&
      !backgroundProvenanceData.current &&
      mapContext.currentBackgroundData?.provenances?.length === 0 &&
      mapContext.currentExtent?.zoomLevel > 15 &&
      userContext.currentUser?.hasProperty
    ) {
      GetBackgroundProvenanceData();
    }

    return () => {
      setData([{ uprn: 0, address: "Loading Data...", postcode: "" }]);
      controller.abort();
    };
  }, [search, urlDetails, searchContext, userContext, mapContext, settingsContext, variant]);

  useEffect(() => {
    switch (variant) {
      case "appBar":
        setMaxResults(8);
        break;

      default:
        setMaxResults(20);
        break;
    }
  }, [variant]);

  useEffect(() => {
    setHasASD(userContext.currentUser && userContext.currentUser.hasASD);
  }, [userContext]);

  return (
    <Fragment>
      <Autocomplete
        id={`ads-${variant}-search`}
        open={searchContext.searchPopupOpen}
        sx={{ color: "inherit", pr: "24px" }}
        getOptionLabel={(option) => addressToTitleCase(option.address, option.postcode)}
        isOptionEqualToValue={(option, value) => option.address === value.address}
        filterOptions={(x) => x}
        noOptionsText="No search results"
        options={data.length > maxResults ? data.slice(0, maxResults) : data}
        onOpen={() => {
          if (search) {
            searchContext.onSearchOpen(true);
          }
        }}
        onClose={() => {
          searchContext.onSearchOpen(false);
        }}
        value={value}
        onChange={onSelectCheck}
        inputValue={inputValue}
        onInputChange={onSearchChange}
        onFocus={onSearchFocus}
        onBlur={onSearchBlur}
        renderOption={(props, option, state, ownerState) => {
          const { key, ...optionProps } = props;
          return (
            <Box
              key={key}
              sx={{
                color: adsMidGreyA,
                "&:hover": { cursor: "pointer", color: adsBlueA, backgroundColor: adsPaleBlueA },
              }}
              component="li"
              {...optionProps}
            >
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                spacing={1}
                sx={{
                  color: adsMidGreyA,
                  "&:hover": { cursor: "pointer", color: adsBlueA, backgroundColor: adsPaleBlueA },
                }}
              >
                {option.type === 15 ? <StreetIcon /> : GetClassificationIcon(option.classification_code)}
                <Typography sx={{ fontSize: "15px" }}>{addressToTitleCase(option.address, option.postcode)}</Typography>
              </Stack>
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            ref={params.InputProps.ref}
            variant="standard"
            placeholder={placeholder}
            sx={getSearchStyle()}
            fullWidth
            onKeyDownCapture={handleKeyDown}
            slotProps={{
              input: {
                disableUnderline: true,
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      id="btnSearch"
                      disabled={!inputValue || inputValue.length < 2}
                      onClick={handleSearchCheck}
                      aria-label="search button"
                      size="large"
                    >
                      <SearchIcon sx={ActionIconStyle()} />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton id="btnClear" onClick={handleClearSearch} aria-label="clear button" size="small">
                      <ClearIcon sx={ClearSearchIconStyle(search)} />
                    </IconButton>
                    {process.env.NODE_ENV === "development" && showIcons && variant === "appBar" && (
                      <IconButton id="filter-button" onClick={handleFilterClick} aria-label="filter button">
                        <FilterListIcon sx={ActionIconStyle()} />
                      </IconButton>
                    )}
                    {process.env.NODE_ENV === "development" && showIcons && variant === "appBar" && (
                      <IconButton
                        id="query-builder-button"
                        disabled
                        onClick={handleQueryBuilderClick}
                        aria-label="query builder button"
                      >
                        <TuneIcon sx={ActionIconStyle()} />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              },
            }}
          />
        )}
        slots={{
          popper: StyledPopper,
        }}
      />
      <Popper id={filterId} open={filterOpen} anchorEl={filterAnchorEl} placement="bottom-end">
        <ADSFilterControl searchButton="Search" onFilter={handleFilterResults} onCancel={handleCancelFilter} />
      </Popper>
      <Snackbar
        open={saveOpen}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        onClose={handleSaveClose}
      >
        <Alert
          sx={GetAlertStyle(saveResult.current)}
          icon={GetAlertIcon(saveResult.current)}
          onClose={handleSaveClose}
          severity={GetAlertSeverity(saveResult.current)}
          elevation={6}
          variant="filled"
        >{`${
          saveResult.current
            ? `The ${saveType.current} has been successfully saved.`
            : failedValidation.current
              ? `Failed to validate the ${saveType.current} record.`
              : `Failed to save the ${saveType.current}.`
        }`}</Alert>
      </Snackbar>
      {/* // TODO: uncommented below code when want to reintroduce asking to edit historic. */}
      {/* <HistoricPropertyDialog open={openHistoricProperty} onClose={handleHistoricPropertyClose} /> */}
    </Fragment>
  );
}

export default ADSSearch;
